import React, { useContext } from 'react'
import MyContext from '../../context/data/myContext';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';

function SearchBar9() {
    const context = useContext(MyContext)
    const { filteredData9, wordEntered9, handleFilter9, clearInput9 } = context
  return (
    <div>
        <div className="ml-auto flex items-center">
              <input type="text" placeholder='Buscar...' value={wordEntered9} onChange={handleFilter9} style={{outline: 'none'}} className='bg-gray-100'/>
                <div>
                    {filteredData9.length === 0 ? (<SearchIcon/>) : (<CloseIcon  id="clearBtn" onClick={clearInput9} />) }
                </div>
              </div>
      
    </div>
  )
}

export default SearchBar9